import { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import DefaultLayout from './layout/DefaultLayout';
import CustomerLayout from './layout/CustomerLayout';
import ProtectedRoute from './feature-module/frontend/auth/ProtectedRoute';
import { ROLE } from './Role';
import MemebershipPlanCallBack from './feature-module/frontend/auth/MemebershipPlanCallBack';
import ErrorPage from './feature-module/staticPages/ErrorPage';
import SessionWatcher from './feature-module/components/SessionWatcher';
import CollectPhoneModal from './feature-module/components/common/ui/CollectPhoneModal';
import ErrorBoundary from './utils/erros/ErrorBoundary';
import FulLoading from './feature-module/components/common/ui/loading/FullLoading';
import { Helmet } from 'react-helmet-async';
import TelemetryPageViews from './components/TelemetryPageViews';
import CookieConsentBanner from './components/CookieConsentBanner';
import { ProwlSessionProvider } from './lib/prowl/ProwlSessionContext';

const ProfileSettings = lazy(
  () =>
    import('./feature-module/frontend/Customer/ProfileSettings/ProfileSettings')
);

function App() {
  return (
    <BrowserRouter>
      <SessionWatcher />
      <TelemetryPageViews />
      <CookieConsentBanner />
      <CollectPhoneModal />
      <Suspense fallback={<FulLoading />}></Suspense>
      <ErrorBoundary>
        {/* Wraps the router output (not BrowserRouter itself) so a route
            change never unmounts the Prowl conversation — see
            ProwlSessionContext.tsx. */}
        <ProwlSessionProvider>
          <Routes>
            {/* Redirect root path to /home */}
            <Route path="/" element={<Navigate to="/home" replace />} />

            {/* Main layout */}
            <Route path="/*" element={<DefaultLayout />} />

            {/* Customer layout — noindex for dashboard pages */}
            <Route
              path="/customer/*"
              element={
                <>
                  <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                  </Helmet>
                  <ProtectedRoute allowedRoles={[ROLE.CUSTOMER, ROLE.PROVIDER]}>
                    <CustomerLayout />
                  </ProtectedRoute>
                </>
              }
            />

            {/* Handle invalid paths */}
            <Route path="*" element={<Navigate to="/home" replace />} />

            {/* Centralized Profile Settings — standalone, no sidebar */}
            <Route
              path="/profile-settings"
              element={
                <ProtectedRoute allowedRoles={[ROLE.CUSTOMER, ROLE.PROVIDER]}>
                  <Suspense fallback={<FulLoading />}>
                    <ProfileSettings />
                  </Suspense>
                </ProtectedRoute>
              }
            />

            <Route path="/error" element={<ErrorPage />} />

            <Route
              path="/membership-plan-callback"
              element={<MemebershipPlanCallBack />}
            />
          </Routes>
        </ProwlSessionProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
